import api from './api'

export const promoApi = {
  request: (body) => api.post('/v1/promo/request', body).then((r) => r.data),
  redeem: (code) => api.post('/v1/promo/redeem', { code }).then((r) => r.data),
}

export default promoApi
